/**
 * SSC REST API Client
 *
 * Singleton RestClient for SSC (Single Service Calculator) API.
 * All SSC calls are POST with Login: {} (auth via API Gateway).
 */
import { RestClient } from '../shared/restClient';
import { SSC_CONFIG } from './config';

export const sscClient = new RestClient({
  baseURL: SSC_CONFIG.ENDPOINT,
  timeout: SSC_CONFIG.TIMEOUT,
  retryConfig: {
    retries: SSC_CONFIG.RETRY.maxAttempts,
    retryDelay: (retryCount) => SSC_CONFIG.RETRY.initialDelay * Math.pow(2, retryCount - 1),
  },
});
